module.exports = __webpack_public_path__ + "static/media/bluefish2.2b0f455f.png";